/* eslint-disable */
var $ = window.jQuery = require('jquery');
import {
  mapGetters
} from 'vuex';
import toast from '../../services/toast';
import {
  bus
} from '../../main';
export default {
  name: 'trash-user',
  components: {},
  props: ['userTrashID'],
  data () {
    return {
      password:'',
      userTrashId:'',
      userTrashFirstName:'',
      userTrashLastName:'',
      userTrashEmail:'',
    }
  },
  computed: {
    userDetailsContent(){
      this.$store.dispatch('getUserListDetailsById', {
        id: this.userTrashID
      })
      .then((res) => {
        this.userTrashFirstName = res.data.data.user_details.first_name
        this.userTrashLastName = res.data.data.user_details.last_name
        this.userTrashEmail = res.data.data.user_details.email
      }).catch((err) => {
        
      })
    }
  },
  mounted () {
    this.userDetailsContent
  },
  methods: {
    getUserListAgain() {
      this.$store.dispatch('getUserListDetails').then((res) => {}).catch((err) => {})
    },
    PopupClose(){
      bus.$emit('UserAcTrashPopupBus', false);
    },
    userAcTrashPopupConfirmation(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            password: this.password
          }
          this.$store.dispatch('userAccountDelete', {
            data: {
              id: this.userTrashID,
              data: data
            }
          }).then((res) => {
            if (res.status == '200') {
              bus.$emit('UserAcTrashPopupBus', false);
              this.password = ''
              this.getUserListAgain()
              toast.success(res.data.msg);
            }
          }).catch((err) => {
            toast.error(err.data.msg || "Password is correct");
    
          })
        }
      })
    }
  }
}


